import { JSONContent } from "@tiptap/core";

const LEADING_INDENT_REGEX = /^[ \t]+/;

/**
 * Markdown treats 4+ leading spaces as an indented code block, so a message
 * typed as "    *hi*" would render literally. Leading indentation never carries
 * meaning in a chat paragraph, so drop it (code blocks keep theirs).
 */
export const stripParagraphIndent = (node: JSONContent): JSONContent => {
  if (node.type === "codeBlock" || !node.content) return node;

  const content = node.content.map(stripParagraphIndent);
  const [firstChild, ...restChildren] = content;

  if (node.type !== "paragraph" || firstChild?.type !== "text") {
    return { ...node, content };
  }

  const text = (firstChild.text ?? "").replace(LEADING_INDENT_REGEX, "");
  const trimmedContent = text
    ? [{ ...firstChild, text }, ...restChildren]
    : restChildren;

  return { ...node, content: trimmedContent };
};
